'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dApp$002dUpdate$002dInfo from "./app.api.-General-Practice-App-Update$-App-Update-Info.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ as $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ };
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ as $h_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ };
$h_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$.prototype.toString__T = (function() {
  return "AppUpdateInfo";
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$.prototype.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo = (function(x$0) {
  var ev$13 = x$0.productElement__I__O(0);
  var buildTime$2 = ((ev$13 === null) ? null : ev$13.Lframework_data_FrameworkDateTime__f_ldt);
  return new $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dApp$002dUpdate$002dInfo.$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo(buildTime$2);
});
$c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo(p);
});
var $d_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$, "app.api.GeneralPracticeAppUpdate$AppUpdateInfo$", ({
  Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ as $d_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ };
var $n_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$;
function $m_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$() {
  if ((!$n_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$)) {
    $n_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ = new $c_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$();
  }
  return $n_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$;
}
export { $m_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ as $m_Lapp_api_GeneralPracticeAppUpdate$AppUpdateInfo$ };
//# sourceMappingURL=app.api.-General-Practice-App-Update$-App-Update-Info$.js.map
